import {
  CORE_LOAD_AMENITIES_REQUEST,
  CORE_LOAD_AMENITIES_SUCCESS
} from '../../types'

const initialState = []
export default {
  amenities: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_AMENITIES_REQUEST:
        return initialState
      case CORE_LOAD_AMENITIES_SUCCESS:
        if (action.payload[0]) {
          let payload = action.payload[0]
          let amenities = []
          for (let i = 0; i < payload.length; i++) {
            amenities.push({
              name: payload[i].name,
              maxRequest: payload[i].maxRequest,
              seq: payload[i].seq,
              _id: payload[i]._id
            })
          }
          return amenities
        }
        else return [{}]

      default:
        return state
    }
  }
}


// WEBPACK FOOTER //
// ./src/features/amenity/reducer.js